import { tap, catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { ServiceBase } from 'app/shared/serviceBase'
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { User } from 'app/shared/models/User';
import { NewUser } from 'app/account/models/new-user.model';
import { UserType } from 'app/account/models/user-type.model';
import { HttpClient } from '@angular/common/http';
import { CompanyListModel } from 'app/company/models/company-list.model';
import { AddCompanyUserModel } from 'app/account/models/add-company-user.model';
import { CompanyUser } from 'app/account/models/company-user.model';

@Injectable()
export class UserService extends ServiceBase {
    private commonUrl: string = this.url + '/Account/';

    constructor(private _http: HttpClient, private _authentication: AuthenticationService) { super(); }

    registerUser(newUser: NewUser): Observable<string> {
        const completeUrl: string = this.commonUrl + 'RegisterNewUser';
        return this._http.post<string>(completeUrl, newUser).pipe(
            catchError(this.handleError));
    }

    //getUserTypes(): Observable<UserType[]> {
    //       const completeUrl: string = this.commonUrl + 'GetUserTypes';
    //       return this._http.get<UserType[]>(completeUrl).pipe(
    //           catchError(this.handleError));
    //   }
    
    deleteUser(userId: string): Observable<Response> {
        const completeUrl: string = this.commonUrl + 'siteUser/' + userId;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }

    getUsers(): Observable<User[]> {
        const completeUrl: string = this.commonUrl + 'Users';
        return this._http.get<User[]>(completeUrl).pipe(
            catchError(this.handleError));
    }

    getUser(id: string): Observable<User> {
        const completeUrl: string = this.commonUrl + id;
        return this._http.get<User>(completeUrl).pipe(
            catchError(this.handleError));
    }

    editUser(newUser: User): Observable<Response> {
        const completeUrl: string = this.commonUrl + 'UpdateUser';
        return this._http.post<Response>(completeUrl, newUser).pipe(
            catchError(this.handleError));
    }

    existsUserByEmail(email: string): Observable<boolean> {
        const completeUrl: string = this.commonUrl + 'exists-by-email/' + email;
        return this._http.get<boolean>(completeUrl).pipe(
            catchError(this.handleError));
    }

    getCompanyUsers(userId: string): Observable<CompanyListModel[]> {
        const completeUrl: string = this.commonUrl + 'company/' + userId;
        return this._http.get<CompanyListModel[]>(completeUrl).pipe(
            catchError(this.handleError));
    }

    deleteCompanyUser(companyUserId: string): Observable<Response> {
        const completeUrl: string = this.commonUrl + 'company/' + companyUserId;
        return this._http.delete(completeUrl).pipe(
            map((response: Response) => response),
            catchError(this.handleError));
    }

    addCompanyToUser(newUser: AddCompanyUserModel): Observable<string> {
        const completeUrl: string = this.commonUrl + 'company';
        return this._http.post<string>(completeUrl, newUser).pipe(
            catchError(this.handleError));
    }

    getUserTypes(): Observable<UserType[]> {
        const completeUrl: string = this.commonUrl + 'UserTypes';
        return this._http.get<UserType[]>(completeUrl).pipe(
            catchError(this.handleError));
    }

    updateCompanyUserType(companyUser: CompanyUser): Observable<Response> {
        const completeUrl: string = this.commonUrl + 'UpdateCompanyUserType';
        return this._http.post<Response>(completeUrl, companyUser).pipe(
            catchError(this.handleError));
    }
}
